import React, { useState, useEffect, useCallback } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CasinoSection from '../components/CasinoSection';
import LuckyDrawSection from '../components/LuckyDrawSection';
import PredictionSection from '../components/PredictionSection';
import PlayVaultPanel from '../components/PlayVaultPanel';
import MoreGamesSection from '../components/MoreGamesSection';
import { useWeb3 } from '../context/Web3Context';
import { useLanguage } from '../context/LanguageContext';
import api from '../utils/api';
import './PlayPage.css';

const PlayPage = () => {
  const { isConnected } = useWeb3();
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('luckyDraw');
  const [vaultBalance, setVaultBalance] = useState('0');
  const [platformEarnings, setPlatformEarnings] = useState('0');

  const fetchVaultInfo = useCallback(async () => {
    if (!isConnected) return;
    try {
      const res = await api.get('/play-vault');
      setVaultBalance(res.data.userBalance || '0');
      setPlatformEarnings(res.data.platformEarnings || '0');
    } catch (_) { /* vault not deployed or wallet not connected */ }
  }, [isConnected]);

  useEffect(() => { fetchVaultInfo(); }, [fetchVaultInfo]);

  return (
    <div className="play-page">
      <Header />

      <main className="play-main">
        <section className="play-hero">
          <h1>{t('play')}</h1>
        </section>

        {isConnected && (
          <section className="play-vault-section">
            <PlayVaultPanel
              vaultBalance={vaultBalance}
              platformEarnings={platformEarnings}
              onRefresh={fetchVaultInfo}
            />
          </section>
        )}

        <nav className="play-tabs">
          <button
            className={`play-tab ${activeTab === 'luckyDraw' ? 'play-tab-active' : ''}`}
            onClick={() => setActiveTab('luckyDraw')}
          >
            {t('luckyDraw')}
          </button>
          <button
            className={`play-tab ${activeTab === 'predictions' ? 'play-tab-active' : ''}`}
            onClick={() => setActiveTab('predictions')}
          >
            {t('predictions')}
          </button>
          <button
            className={`play-tab ${activeTab === 'games' ? 'play-tab-active' : ''}`}
            onClick={() => setActiveTab('games')}
          >
            Games
          </button>
        </nav>

        <section className="play-content">
          {activeTab === 'luckyDraw' && <LuckyDrawSection />}
          {activeTab === 'predictions' && <PredictionSection />}
          {activeTab === 'games' && (
            <>
              <CasinoSection
                vaultBalance={vaultBalance}
                platformEarnings={platformEarnings}
                onBalanceRefresh={fetchVaultInfo}
              />
              <MoreGamesSection
                vaultBalance={isConnected ? vaultBalance : undefined}
                onBalanceRefresh={fetchVaultInfo}
              />
            </>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PlayPage;
